import { vdkEmHappinessPortalApi } from './vdk-em-happiness-portal-api';
const getAllEvents = () => {
    return vdkEmHappinessPortalApi.get(`/get-all-events`);
};
const getEventPublicAccessInfo = (id) => {
    return vdkEmHappinessPortalApi.get(`/get-event-public-access-info?id=${id}`);
};
const getEventStats = (id) => {
    return vdkEmHappinessPortalApi.get(`/get-invitation-stats?id=${id}`);
};
const getPaginatedInvitationsByEventId = (data) => {
    return vdkEmHappinessPortalApi.post(`/get-paginated-invitation-by-event-id`, data);
};
const exportToExcel = (data) => {
    return vdkEmHappinessPortalApi.post(`/export-to-excel`, data);
};
const getAllPickupLocations = () => {
    return vdkEmHappinessPortalApi.get(`/get-all-pickup-locations`);
};
const f1IntegrationApi = {
    getAllEvents,
    getEventStats,
    getPaginatedInvitationsByEventId,
    exportToExcel,
    getAllPickupLocations,
    getEventPublicAccessInfo
};
export default f1IntegrationApi;
